import { requester, RequestInfo } from '@data/api/requester'
import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import useDeepCompareEffect from 'use-deep-compare-effect'

type TrackingEventArgs = {
    eventName?: TTrackingEvent
    eventParams?: EventParams
}

type Data = TTrackingEvent
type Options = UseMutationOptions<Data, ApiError, TrackingEventArgs>
// @TODO improve typing here
type EventParams = Record<string, unknown>

/** BE route: tracking_api_track_post */
const trackingPostRequest = ({ eventName, eventParams }: TrackingEventArgs): RequestInfo<Data> => {
    return {
        method: 'POST',
        url: `/t/events/${eventName}`,
        body: eventParams,
    }
}

const mutationFn = (requestArgs: TrackingEventArgs) => requester(trackingPostRequest(requestArgs))

const useTrackingEventMutation = (options?: Options): UseMutationResult<Data, ApiError, TrackingEventArgs> =>
    useMutation({
        ...options,
        mutationFn,
    })

export const useEarlyStepsEventTracking = (
    eventName?: TTrackingEvent,
    params?: EventParams
): UseMutationResult<Data, ApiError, TrackingEventArgs> => {
    const result = useTrackingEventMutation()

    useDeepCompareEffect(() => {
        if (!eventName) {
            return
        }

        result.mutate({
            eventName,
            eventParams: {
                ...params,
            },
        })
    }, [eventName, result.mutate, params])

    return result
}
